<!--个人认证-->
<template>
  <div class="personal-certification-container" @click="openFullScreen">
    <div class="personal-certification-content">
      <p class="tips">适用于个体职业用户与某一领域内容创作者身份确认</p>
      <p class="small-title">身份证信息</p>
      <el-form ref="personalForm0" :model="personalForm" :disabled="disabled" :rules="personalRules" label-width="110px" style="width: 50%" label-position="left">
        <el-form-item label="姓名：" prop="name">
          <el-input v-model="personalForm.name"/>
        </el-form-item>
        <el-form-item label="身份证号：" prop="id_number">
          <el-input v-model="personalForm.id_number"/>
        </el-form-item>
      </el-form>
      <el-form :model="personalForm" :rules="personalRules" :disabled="disabled" ref="personalForm1" label-position="top">
        <el-form-item label="上传身份证：" prop="positive">
          <div style="display: flex;">
            <el-upload class="avatar-uploader" action="http://bqwapi.bangqichat.com/home/rest/uploadImgForWangsuyun/uploadImg" style="margin-right: 20px" :on-success="successUpload" :show-file-list="false">
              <el-image v-if="personalForm.positive" fit="cover" :src="personalForm.positive" style="width: 100px;height: 100px;border-radius: 6px;"/>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div class="el-upload__tip" slot="tip">身份证正面</div>
            </el-upload>
            <el-upload class="avatar-uploader" action="http://bqwapi.bangqichat.com/home/rest/uploadImgForWangsuyun/uploadImg" :on-success="successUpload2" :show-file-list="false">
              <el-image v-if="personalForm.reverse" fit="cover" :src="personalForm.reverse" style="width: 100px;height: 100px;border-radius: 6px;"/>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div class="el-upload__tip" slot="tip">身份证反面</div>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <p class="small-title">认证信息</p>
      <el-form ref="attestationForm0" :model="attestationForm" :disabled="disabled" :rules="attestationRules" label-width="110px" style="width: 50%" label-position="left">
        <el-form-item label="职位/称号：" prop="position">
          <el-cascader v-model="attestationForm.position" placeholder="" :options="jobClass" :props="{ expandTrigger: 'hover' }" clearable :show-all-levels="false"/>
        </el-form-item>
        <el-form-item label="单位/组织：" prop="unit">
          <el-input v-model="attestationForm.unit"/>
        </el-form-item>
        <el-form :model="attestationForm" :rules="attestationRules" :disabled="disabled" ref="attestationForm1" label-position="top">
          <el-form-item label="认证材料：" prop="stuff">
            <div style="display: flex;">
              <el-upload class="avatar-uploader" action="http://bqwapi.bangqichat.com/home/rest/uploadImgForWangsuyun/uploadImg" :on-success="successUpload3" :show-file-list="false">
                <el-image v-if="attestationForm.stuff" fit="cover" :src="attestationForm.stuff" style="width: 100px;height: 100px;border-radius: 6px;"/>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
        <el-form-item prop="isRead" label-width="0px">
          <el-checkbox v-model="attestationForm.isRead">我已阅读并同意<el-link class="el-active" :underline="false" @click="privacyPolicy">《隐私政策》</el-link></el-checkbox>
        </el-form-item>
        <el-form-item label-width="0px">
          <el-button @click="submitForm" :disabled="attestationForm.isRead ? false : true" type="danger">提交审核</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import {validateSfz} from '@/common/validateSfz';
import {jobClassification,reviewAuthenticationForEight} from '@/api/systemSetting'
export default {
  name: "personalCertification",
  data() {
    const uploadIdentityCard = (rule, value, callback) => {
      if (this.personalForm.positive == '') {
        callback(new Error('请上传身份证正面'));
      } else if (this.personalForm.reverse == '') {
        callback(new Error('请上传身份证背面'));
      } else {
        callback();
      }
    }
    const checkRead = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请阅读并同意《隐私政策》'));
      }else{
        callback();
      }
    }
    return {
      personalForm:{
        name:'',
        ID_NUMBER:'',
        positive:'',
        reverse:'',
      },
      attestationForm:{
        position:'',
        unit:'',
        stuff:'',
        isRead:false
      },
      personalRules:{
        name:[
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        id_number:[
          { required: true, validator: validateSfz, trigger: "blur" }
        ],
        positive:[
          { required: true, validator: uploadIdentityCard, trigger: "change" }
        ]
      },
      attestationRules:{
        position:[
          { required: true, message: '请选择职位/称号', trigger: 'change' }
        ],
        unit:[
          { required: true, message: '请输入单位/组织', trigger: 'blur' }
        ],
        stuff:[
          { required: true, message: '请上传认证材料', trigger: 'change' }
        ],
        isRead:[
          { required: true, validator: checkRead, trigger: "change" }
        ]
      },
      jobClass:[],
      userInfo:{},
    }
  },
  props:{
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  methods:{
    /*图片上传成功后处理-身份证正面*/
    successUpload(response, file, fileList) {
      this.personalForm.positive = response.imgPath;
    },
    /*图片上传成功后处理-身份证反面*/
    successUpload2(response, file, fileList) {
      this.personalForm.reverse = response.imgPath;
    },
    /*认证材料*/
    successUpload3(response, file, fileList) {
      this.attestationForm.stuff = response.imgPath;
    },
    /*获取职位信息*/
    getJobClassification(){
      jobClassification().then(res=>{
        if (res.code==200){
          this.jobClass=res.content.list
        }
      })
    },
    /*隐私政策*/
    privacyPolicy(){
      window.open('https://customerservice.bangqichat.com/index/agreement/article?aWQ9MjA=', '_blank')
    },
    /*提交审核*/
    submitForm(){
      let that = this;
      let can = 0,can1=0;
      for (let a = 0; a < 2; a++) {
        that.$refs['personalForm'+a].validate((valid) => {
          if (valid) {} else {
            can++;
            return false;
          }
        });
      }
      if (can==0){
        for (let a = 0; a < 2; a++) {
          that.$refs['attestationForm'+a].validate((valid) => {
            if (valid) {} else {
              can1++;
              return false;
            }
          });
        }
        if (can1==0){
          let position='';
          for (let list of that.jobClass){
            if (list.value==that.attestationForm.position[0]){
              for (let sub of list.children){
                if (sub.value==that.attestationForm.position[1]){
                  position=sub.label
                }
              }
            }
          }
          let formData={
            bqwCertificationEightVO: {
              id: 0,
              realname: that.personalForm.name,
              idenitityNum: that.personalForm.id_number,
              position: position,
              institutionName: that.attestationForm.unit,
              identityimgFront: that.personalForm.positive,
              identityimgBack: that.personalForm.reverse,
              certificationProofList: [{
                certificationId: null,
                id: null,
                proofType: 4,
                proofUrl: that.attestationForm.stuff
              }],
              showOrganization: 1,
              verifiedType: 1,
              cid: that.userInfo.cid
          },
            certificationProofList: [{
              certificationId: null,
              id: null,
              proofType: 4,
              proofUrl: that.attestationForm.stuff
            }],
            uid: that.userInfo.cid
          }
          reviewAuthenticationForEight(formData).then(res=>{
            if (res.code==200){
              that.$alert('个人认证信息提交成功，正在审核，请耐心等待。', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  window.location.reload()
                }
              });
            }
          })
        }
      }else{
        for (let a = 0; a < 2; a++) {
          that.$refs['attestationForm'+a].validate((valid) => {
            if (!valid) {
              return false;
            }
          });
        }
      }
    },
    /*页面点击提示*/
    openFullScreen(){
      if (this.disabled){
        const loading = this.$loading({
          lock: true,
          text: '认证信息审核中！',
          spinner: '',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 2000);
      }
    }
  },
  mounted() {
    this.getJobClassification();
  },
  beforeMount() {
    this.userInfo=sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')) : {};
  }
}
</script>
<style scoped>
.personal-certification-container >>> .personal-certification-content .el-upload {
  border: 1px solid #F2F2F2;
  background: #F2F2F2;
  border-radius: 6px;
  width: 100px;
  height: 100px;
  line-height: 100px;
  font-size: 25px;
  color: #666;
}
.personal-certification-container >>> .personal-certification-content .el-upload__tip {
  font-size: 14px;
  color: #333333;
  margin-top: 0px;
  text-align: center;
}
.personal-certification-container >>> .personal-certification-content .el-cascader {
  width: 100%;
}
.personal-certification-container >>> .personal-certification-content .el-checkbox__label {
  display: inline-flex;
  font-size: 14px;
  color: #333333;
}
.personal-certification-container >>> .personal-certification-content .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  width: 30%;
  padding: 15px;
}
.personal-certification-container >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.personal-certification-container >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #1637FF;
  border-color: #1637FF;
}
</style>
<style scoped lang="scss">
.personal-certification-container {
  .personal-certification-content {
    .tips{
      margin-block-end: 0px;
      margin-block-start: 0px;
      font-size: 14px;
      color: #666666;
    }
    .small-title{
      margin-block-end: 20px;
      margin-block-start: 20px;
      font-size: 16px;
      font-family: 'SourceHanSansCN';
      color: #333333;
    }
    .el-active{
      color: #1637FF;
    }
  }
}
</style>
<style>
.el-loading-spinner .el-loading-text {
  color: #ffffff;
}
.el-loading-spinner .path {
  stroke: #ffffff;
}
</style>